import { useRouterState } from '@tanstack/react-router';
import LogRocket from 'logrocket';
import { useEffect } from 'react';
import ServerErrorSVG from 'src/assets/img/server-error.svg?react';
import { useDocumentTitle } from '../_hooks/useDocumentTitle';
import { CopyrightFooter } from '../Authentication/Account/elements/Footer';

export const ServerErrorPage = () => {
  // biome-ignore lint/suspicious/noExplicitAny: router constraint bypass
  const error = useRouterState({ select: (s: any) => s.error });

  useDocumentTitle('Server Error');

  useEffect(() => {
    // biome-ignore lint/suspicious/noExplicitAny: router constraint bypass
    if ((error as any) instanceof Error) {
      LogRocket.captureException(error as unknown as Error);
      return;
    }

    LogRocket.error('Unhandled client-side error');
  }, [error]);

  return (
    <div className='server-error-page'>
      <div className='main-body'>
        <div className='header-wrapper'>
          <h2>Server Error</h2>
          <span>The server encountered an error while rendering the page.</span>
        </div>
        <div className='illustration-wrapper'>
          <ServerErrorSVG />
        </div>
      </div>
      <CopyrightFooter />
    </div>
  );
};
